import { defineAsyncComponent } from 'vue'
export default {
  "admin-login": defineAsyncComponent(() => import("/var/www/panel/layouts/admin-login.vue").then(m => m.default || m)),
  "clear-logo": defineAsyncComponent(() => import("/var/www/panel/layouts/clear-logo.vue").then(m => m.default || m)),
  panel: defineAsyncComponent(() => import("/var/www/panel/layouts/panel.vue").then(m => m.default || m))
}